var _templateObject, _defs, _path, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgPlaceholder = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174 174"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_placeholder_svg__a",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f2eee3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d8d2c3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_placeholder_svg__a)",
    stroke: "#212744",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M17.9 99.9c0 5.2 1.7 10.3 5.6 14.1l50.1 50.1c7.5 7.5 19.6 7.5 27 0l50.1-50.1c3.9-3.9 5.6-9.1 5.6-14.1V74.4c0-5.1-1.7-10.3-5.6-14.1l-50.1-50.2c-7.5-7.5-19.6-7.5-27 0L23.5 60.2c-3.9 3.9-5.6 9-5.6 14.1v25.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 22,
    fill: "none",
    stroke: "#212744",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 87,
    y: 96,
    fill: "#212744",
    fontFamily: "monospace",
    fontSize: 28,
    fontWeight: 700,
    textAnchor: "middle"
  }, "?"))));
};
export default SvgPlaceholder;